import React from 'react';
import Link from 'next/link';
import { SCHOOL_LISTINGS_USER_ACTION } from 'consts';
import { ClickPortalNavItem } from 'types';
import { setSchoolListingsUserActionForSearchLink } from 'utils/schoolListingsUserAction';

interface ClickPortalResultRowsNavProps {
  label?: string;
  navItems?: ClickPortalNavItem[];
}

export default function ClickPortalResultRowsNav({
  label,
  navItems,
}: ClickPortalResultRowsNavProps): React.JSX.Element | null {
  if (!navItems?.length) {
    return null;
  }

  return (
    <nav
      className="clickPortalResultRowsSection__nav"
      aria-label={label || 'Portal results'}
      data-testid="clickPortalResultRowsSection__nav"
    >
      {label && (
        <div className="clickPortalResultRowsSection__navLabel">{label}</div>
      )}
      <ul className="clickPortalResultRowsSection__navList">
        {navItems.map((item) => (
          <li
            className="clickPortalResultRowsSection__navItem"
            key={`${item.label}_${item.url}`}
          >
            <Link
              prefetch={false}
              href={item.url}
              target={item.target || undefined}
              rel={item.target === '_blank' ? 'noreferrer noopener' : undefined}
              className="clickPortalResultRowsSection__navLink"
              onClick={() => {
                setSchoolListingsUserActionForSearchLink(
                  item.url,
                  SCHOOL_LISTINGS_USER_ACTION.USER_SECONDARY_NAVIGATION
                );
              }}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
